<template>
  <tr>
    <td>
      <table>
        <tr>
          <td>
            <font style="text-align: left; font-weight: bold; font-size: 20px; color: #000000">
              {{ item.product.hotel_name }}
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Booking Reference:
              <span style="font-size: 20px;" :style="{'text-decoration': item.booking.booking_mode == 'Cancelled' ? 'line-through' : 'none' }">
                {{ item.booking.booking_ref }}
              </span>
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong v-if="item.booking.booking_mode == 'Cancelled'">
                <font style="font-weight:bold;color:#FF0000;">
                  Status: {{ item.booking.booking_mode }}
                </font>
              </strong>
              <span v-else style="font-weight:bold; color:#00638c; font-size: 14px;">
                Status: {{ item.booking.booking_mode }}  
              </span>
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Arrival date: {{ stayOn }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Room: {{ item.booking.supplier_confirmation.booking.booking_details.number_of_rooms }} x {{ item.booking.supplier_confirmation.booking.booking_details.room_type }} 
              Room, <span v-html="item.booking.supplier_confirmation.booking.booking_details.rate_description"></span>
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Price: &pound;{{ item.booking.sale_price.toFixed(2) }}
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Directions:</font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">Address:</font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <span v-if="item.booking.supplier_confirmation.booking.hotel_info.address.line1 != ''">
                {{ item.booking.supplier_confirmation.booking.hotel_info.address.line1 }}
                <br/>
              </span>

              <span v-if="item.booking.supplier_confirmation.booking.hotel_info.address.line2 != ''">
                {{ item.booking.supplier_confirmation.booking.hotel_info.address.line2 }}
                <br/>
              </span>

              {{ item.booking.supplier_confirmation.booking.hotel_info.address.line3 }}
              <br/>
              {{ item.booking.supplier_confirmation.booking.hotel_info.address.town }}
              <br/>
              {{ item.booking.supplier_confirmation.booking.hotel_info.address.county }}
              <br/>
              {{ item.booking.supplier_confirmation.booking.hotel_info.address.postcode }}
              <br />
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Telephone: {{ item.booking.supplier_confirmation.booking.hotel_info.telephone }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;" v-html="item.booking.supplier_confirmation.booking.hotel_info.directions" />
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Terms and Conditions:</font>
          </td>
        </tr>
        <tr>
          <td>
            <font
              style="font-weight: normal; font-size: 14px; color:#000000;"
            >{{ item.booking.supplier_confirmation.booking.hotel_info.booking_terms|raw }}</font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              Full copy available online:
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <a href="/terms-and-conditions?utm_source=sps-confirmation&utm_medium=email&utm_campaign=confirmation-email">
                Terms and conditions
              </a>
            </font>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
import mixins from "@/mixins";
import moment from "moment";

export default {
  name: "confirmation-view-hotel",
  mixins: [mixins.format],
  computed: {
    stayOn() {
      return moment(this.item.booking.stay_on).format(
        "Do MMM YYYY, hh:mm"
      );
    }
  },
  props: {
    item: { type: Object, default: () => {} },
    airporthotel: { type: Number, default: 1 }
  }
};
</script>